export type StrapiContentStatus = null | undefined | 'all' | 'published' | string

export const filterStrapiContentArray = <TContent>(criteria: StrapiContentStatus, content: TContent | undefined): TContent => {
    // console.log('here filtering', criteria, content)
    const con = content as any[];
    if (!con || con.length === 0 || criteria === 'all' || !criteria) return con as TContent;

    return con.filter(e => !Boolean(e?.hidden)) as TContent;
}

export const filterStrapiContentItem = <TContent>(criteria: StrapiContentStatus, content: TContent | undefined): TContent | null => {
    // console.log('here filtering', content)

    const con = content as any;
    if (!con) return con as TContent;

    if (!getStrapiContentItemIsHidden(criteria, con.hidden)) {
        return con;
    }
    else return null
}

export const getStrapiContentItemIsHidden = (criteria: StrapiContentStatus, hidden: boolean | undefined): boolean => {
    // console.log('here filtering', content)

    if (criteria === 'all' || !criteria) return false;

    if (!hidden) {
        return false;
    }
    else return true
}